/**
 * Change styles to owl card slider.
 */
 function owl_card_slider(){
    const elements = document.querySelectorAll(".owl-card-slider-container");    
    if (elements.length) {
        elements.forEach(function (element) { 
            $(element).owlCarousel({
                rewind: true,
                autoplay: true,
                autoplaySpeed: 500,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    630: {
                        items: 2
                    },
                    944: {
                        items: 3
                    },
                    1258: {
                        items: 4
                    }
                }
            });
        });
    }
}

owl_card_slider();

export default owl_card_slider;